import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { UserEntryDatesService } from '../userentrydates/userentrydates.service';
import { UserentrydatesFeaturesComponent } from '../userentrydates/features/userentrydates-features.component';
import { CategoriesService } from '../shared/category/categories.service';
import { processResolver } from './process-resolver';

const log = new LoggingService();
export const UserEntryDatesRoute: Ng2StateDeclaration = {
    name: 'userentrydates',
    url: '/userentrydates',
    data: { requiresAuth: true },
    params: { process: {} },
    resolve: [
        {
            token: 'process',
            deps: [Transition, CategoriesService],
            resolveFn: processResolver
        }
    ],
    component: UserentrydatesFeaturesComponent
};
